<template>
    <div class="panel-body">
        <br>
        <router-link to="/planos-modulo" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <button type="button" :disabled="loading" @click="saveData" class="btn btn-lg btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item">
                            <a class="nav-link active"> <i class="fa fa-tasks"></i>
                                Dados do Módulo</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Tab panes -->
            <div class="card-body">
                <div class="tab-content">
                    <div class="tab-pane active" id="tabFormulario">
                        <span v-html="$t('validation.field_required')"></span>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <required /> <label>Nome</label>
                                    <input class="form-control" :class="{'is-invalid': errors.has('Nome')}" name="Nome"
                                        v-validate="{required: true, max:120}" :placeholder="$t('words.type_name')"
                                        v-model="planoModulo.nome">
                                    <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <required /> <label>Tipo</label>
                                    <select class="form-control" :class="{'is-invalid': errors.has('Tipo')}"
                                        name="Tipo" v-validate="{required: true}"
                                        :placeholder="$t('words.type_description')" v-model="planoModulo.tipo">
                                        <option :value="null">{{$t('words.select')}}</option>
                                        <option :value="'PLANO'">PLANO</option>
                                        <option :value="'ADICIONAL'">ADICIONAL</option>
                                        <option :value="'PRODUTO'">PRODUTO</option>
                                    </select>
                                    <div class="invalid-feedback help-block error">{{errors.first('Tipo')}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <required /> <label>Valor</label>
                                    <money class="form-control" :class="{'is-invalid': errors.has('Valor')}"
                                        name="Valor" v-validate="{required: true}" :placeholder="$t('words.type_name')"
                                        v-model="planoModulo.valor"> </money>
                                    <div class="invalid-feedback help-block error">{{errors.first('Valor')}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <required /> <label>Descrição</label>
                                    <input class="form-control" :class="{'is-invalid': errors.has('Descricao')}"
                                        name="Descricao" v-validate="{required: true, max:120}"
                                        :placeholder="$t('words.type_description')" v-model="planoModulo.descricao">
                                    <div class="invalid-feedback help-block error">{{errors.first('Descricao')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Cor</label>
                                    <input class="form-control" :class="{'is-invalid': errors.has('Cor')}" name="Cor"
                                        v-validate="{required: false, max:20}" :placeholder="'Cor na aba de compras'"
                                        v-model="planoModulo.color">
                                    <div class="invalid-feedback help-block error">{{errors.first('Cor')}}</div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Icone</label>
                                    <input class="form-control" :class="{'is-invalid': errors.has('Icone')}"
                                        name="Icone" v-validate="{required: false, max:20}"
                                        :placeholder="'Icone na aba de compras'" v-model="planoModulo.icon">
                                    <div class="invalid-feedback help-block error">{{errors.first('Icone')}}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="form-group">
                                        <label>Adicionais (publico)</label>
                                        <div class="input-group">
                                            <input v-model="info" :class="{'is-invalid': errors.has('Icone')}"
                                                class="form-control" placeholder="Insira um item">
                                            <span class="input-group-btn">
                                                <button @click="addInfo()" class="btn btn-success"> <i
                                                        class="fa fa-plus"></i>
                                                    Adicionar</button>
                                            </span>
                                        </div>
                                    </div>
                                    <table class="table table-sm table-condensed table-hover">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Descrição</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="planoModulo.info">
                                            <tr v-for="(item, i) in planoModulo.info" :key="i">
                                                <td><a @click="removeInfo(i)" href="#"><i
                                                            class="fa fa-trash text-red"></i></a></td>
                                                <td>{{item}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: null,
                planoModulo: {
                    nome: null,
                    descricao: null,
                    tipo: null,
                    valor: 0,
                    info: [],
                    color: null,
                    icon: null,
                },
                loading: false,
            };
        },

        watch: {
            $route(data) {
                if (this.$route.name === 'planoModuloEdit') {
                    this.getById('getPlanoModuloById').then(response => {
                        this.planoModulo = response;
                    });
                } else {
                    this.resetForm();
                }
            }
        },
        mounted() {
            if (this.$route.name === 'planoModuloEdit') {
                this.getById('getPlanoModuloById').then(response => {
                    this.planoModulo = response;
                });
            }
        },
        methods: {
            saveData() {
                this.loading = true;
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.$route.name === 'planoModuloEdit' ?
                            this.updateData('updatePlanoModulo', this.planoModulo, '/planos-modulo') :
                            this.storeData('storePlanoModulo', this.planoModulo);
                    } else this.loading = false;
                });
            },
            addInfo() {
                if (this.info) {
                    if (!this.planoModulo.info) {
                        this.planoModulo.info = [];
                    }
                    this.planoModulo.info.push(this.info);
                }
                this.info = null;
            },
            removeInfo(i) {
                this.planoModulo.info.splice(i, 1);
            }
        }
    };
</script>